var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import mixpanel from 'mixpanel-browser';
import { runtimeConfig } from './runtimeConfig';
let initialized = false;
const TX_TYPE_TO_EVENT = {
    supply: 'Supply',
    borrow: 'Borrow',
    withdraw: 'Withdraw',
    repay: 'Repay',
    swap_supply: 'Swap Supply',
    swap_repay: 'Swap Repay',
    flash_repay: 'Flash Repay',
    claim_reward: 'Lend Claim Rewards',
};
export const Tracker = {
    init() {
        const token = runtimeConfig.getMixpanelToken();
        if (!token)
            return;
        mixpanel.init(token, {
            debug: runtimeConfig.isDebugLogsEnabled(),
            track_pageview: false,
            persistence: 'localStorage',
        });
        initialized = true;
        mixpanel.unregister('wallet_address');
        mixpanel.unregister('wallet_name');
        mixpanel.unregister('network');
    },
    /**
     * @param newSession When true, calls mixpanel.reset() first. Use when switching wallet
     * address without disconnecting — avoids errAnonDistinctIdAssignedAlready from re-identifying
     * in the same persisted session.
     */
    identify(address, options) {
        if (!initialized)
            return;
        if (options === null || options === void 0 ? void 0 : options.newSession) {
            mixpanel.reset();
        }
        mixpanel.identify(address);
        mixpanel.people.set({ wallet_address: address });
    },
    reset() {
        if (!initialized)
            return;
        mixpanel.reset();
    },
    page(props) {
        if (!initialized)
            return;
        mixpanel.track('Page Viewed', props);
    },
    track(event, props) {
        if (!initialized)
            return;
        mixpanel.track(event, props);
    },
    startTransactionListener() {
        document.addEventListener('transactionSuccess', (e) => {
            var _a;
            const _b = e.detail, { txType } = _b, rest = __rest(_b, ["txType"]);
            const eventName = (_a = TX_TYPE_TO_EVENT[txType]) !== null && _a !== void 0 ? _a : String(txType);
            Tracker.track(`${eventName} Successful`, rest);
        });
        document.addEventListener('transactionError', (e) => {
            var _a;
            const _b = e.detail, { txType } = _b, rest = __rest(_b, ["txType"]);
            const eventName = (_a = TX_TYPE_TO_EVENT[txType]) !== null && _a !== void 0 ? _a : String(txType);
            Tracker.track(`${eventName} Failed`, rest);
        });
    },
};
